import _ from 'lodash';
import { axiosInstance } from '../helpers';
import { deviceType, browserName } from 'react-device-detect';
import { getStoredUser, storeUser } from '../utils/authStorage';

const login = (username, password) => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: { username, password, deviceType, browserName },
  };

  return axiosInstance
    .post(`/users/login`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(user => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      storeUser(user);

      return user;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const getSession = () => {
  return axiosInstance
    .get('/users/session')
    .then(handleResponse);
};

const logout = async () => {
  localStorage.removeItem('user');
  return axiosInstance.post('/users/logout', {});
};

const deleteAccount = async () => {
  const user = getStoredUser();
  console.log(user);
  
  if (user) {
    
    axiosInstance
    .delete(`/users/deleteUser?username=${user.username}`, {
      headers: {
        Authorization: `Bearer ${user.authToken}`
      }
    })
    .then(response => {
      localStorage.removeItem('user');
        return response;
      })
      .catch((err) => {
        console.log("erorrrrrr",err);
        
        // handleResponse(error.response);
        // window.location.reload(true);
      });
  }
};

const refreshToken = () => {
  return axiosInstance
    .post('/users/refreshToken', {})
    .then(response => {
      if (response.data.success) {
        const user = getStoredUser();
        if (user && response.data.authToken) {
          user.authToken = response.data.authToken;
          storeUser(user);
        }

        return response.data.authToken;
      }
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const getAll = () => {
  return axiosInstance
    .get(`/users`)
    .then(handleResponse)
    .then(data => {
      return data.users;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const getById = id => {
  return axiosInstance
    .get(`/users/${id}`)
    .then(handleResponse)
    .then(user => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      storeUser(user);

      return user;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const register = user => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: { ...user },
  };

  return axiosInstance
    .post(`/users/register`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const confirmMobile = props => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: props,
  };

  return axiosInstance
    .post(`/users/confirmMobile`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const resendConfirmationSMS = props => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: props,
  };

  return axiosInstance
    .post(`/users/confirmMobile`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const update = user => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: user,
  };

  return axiosInstance
    .patch(`/users/${user.userId}`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

// prefixed const name with underscore because delete is a reserved word in javascript
const _delete = id => {
  return axiosInstance.delete(`/users/${id}`).then(handleResponse);
};

const authenticate = password => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: { password },
  };

  return axiosInstance
    .post(`/users?authenticate`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const findAllFolders = userId => {
  return axiosInstance
    .get(`/users/${userId}/folders`)
    .then(handleResponse)
    .then(data => {
      return data.folders;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const createFolder = (userId, name) => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: { name },
  };

  return axiosInstance
    .post(`/users/${userId}/folders`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(data => {
      return data.folders;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const deleteFolder = (userId, folderId) => {
  return axiosInstance
    .delete(`/users/${userId}/folders/${folderId}`)
    .then(handleResponse)
    .then(data => {
      return data.folders;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const forgotPassword = props => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: props,
  };

  return axiosInstance
    .post(`/users/forgotPassword`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const resetPassword = props => {
  const requestOptions = {
    headers: { 'Content-Type': 'application/json' },
    body: props,
  };

  return axiosInstance
    .post(`/users/forgotPassword/resetPassword`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .catch(error => {
      handleResponse(error.response);
    });
};

const changeAvatar = (userId, files) => {
  const formData = new FormData();
  files.map(file => {
    formData.append('file', file);
  });

  const requestOptions = {
    headers: { 'Content-Type': 'multipart/form-data' },
    body: formData,
  };

  return axiosInstance
    .post(`/users/${userId}/avatar`, requestOptions.body, requestOptions.headers)
    .then(handleResponse)
    .then(response => {
      return response;
    })
    .catch(error => {
      handleResponse(error.response);
    });
};

const handleResponse = response => {
  if (!response) throw { status: 500 };
  const data = response.data;
  if (!_.includes([200, 201, 204], response.status)) {
    if (response.status === 401 && !response.config.url.includes('/users/login')) {
      // auto logout if 401 response returned from api
      logout();
      window.location.reload(true);
    }

    const error = (data && data.message) || response.statusText;

    // eslint-disable-next-line no-throw-literal
    throw { status: response.status, error };
  }

  return data;
};

export const userService = {
  login,
  getSession,
  logout,
  register,
  refreshToken,
  getAll,
  getById,
  update,
  delete: _delete,
  authenticate,
  findAllFolders,
  createFolder,
  confirmMobile,
  resendConfirmationSMS,
  forgotPassword,
  resetPassword,
  changeAvatar,
  deleteFolder,
  deleteAccount,
};
